import React from 'react';
import { tools } from '../../data/content';
import { CTAButton } from '../CTAButton';
export function Tools() {
  return <section className="bg-navy-900 py-14 sm:py-20" data-id="element-271" data-mp="2mkfpp2xg0wvh">
      <div className="mx-auto w-full max-w-4xl px-4" data-id="element-272" data-mp="2hk1dr9sq12s6">
        <h2 className="text-center font-display text-[27px] font-bold leading-tight text-white sm:text-4xl" data-id="element-273" data-mp="2higitj2hvhts">
          You’ll also get immediate access to
        </h2>

        <ul className="mt-9 grid gap-3 sm:grid-cols-2" data-id="element-274" data-mp="28jmra740thn3">
          {tools.map(tool => <li key={tool.title} className="flex h-full flex-col rounded-2xl bg-white/[0.06] p-5 ring-1 ring-white/10" data-id="element-275" data-mp="23s4pjgu6bd12">
              <span className="text-2xl leading-none" aria-hidden="true" data-id="element-276" data-mp="1yrgxqsy4es5s">
                {tool.emoji}
              </span>
              <h3 className="mt-3 text-[14px] font-extrabold uppercase leading-snug tracking-[0.06em] text-sky-400 sm:text-[15px]" data-id="element-277" data-mp="1pslthmemzs54">
                {tool.title}
              </h3>
              <p className="mt-2 text-[14.5px] leading-relaxed text-white/75" data-id="element-278" data-mp="1kw4we2pgm3fw">{tool.text}</p>
            </li>)}
        </ul>

        <p className="mx-auto mt-9 max-w-xl text-center font-display text-xl font-bold leading-snug text-white sm:text-2xl" data-id="element-279" data-mp="1a0g28pxonhjm">
          Whatever complex mechanic you’re facing, you’ll have a visual framework to structure your analysis
          step by step.
        </p>

        <div className="mx-auto mt-8 max-w-xl" data-id="element-280" data-mp="1nzxvbhi0hgys">
          <CTAButton label="Yes — I want access to the complete system" data-id="element-281" data-mp="1o1909kn70urh" />
        </div>
      </div>
    </section>;
}